import React from "react";
import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import MaterialReactTable from "material-react-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPencil,  faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

const OrganizationLevel = () => {
  const [value, setvalue] = useState("");
  const [OrganizationLevelData, setOrganizationLevelData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [OrganizationLevelValue, setOrganizationLevelValue] = useState("");
  const [OrganizationLevelShortValue, setOrganizationLevelShortValue] = useState("");
  const [deleteCode, setDeleteCode] = useState({});
  const [editCode, setEditCode] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await axios(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/department`
    );
    setOrganizationLevelData(result.data.dataContent);
  };

  useEffect(() => {
    if (flag === true) {
      fetchData();
    }
  }, [flag]);

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },
      {
        accessorKey: "deptName",
        header: "OrganizationLevel Name",
      },
      {
        accessorKey: "deptShortName",
        header: "OrganizationLevel Short Name",
      },
      {
        accessorKey: "visibility",
        header: "Visibility",
      },
      {
        accessor: "",
        header: "Actions",
        Cell: (cell) => (
          <>
            <i
              className="btn text-primary"
              type="button"
              onClick={() => handleEditOrganizationLevel(cell.row.original)}
            >
              <FontAwesomeIcon icon={faPencil} />
            </i>
            <i
              className="btn text-danger"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#myDelete"
              onClick={() =>
                setDeleteCode({
                    deptCode: cell.row.original.deptCode,
                })
              }
            >
              {" "}
              <FontAwesomeIcon icon={faTrashAlt} />
            </i>
          </>
        ),
      },
    ],
    []
  );

  function removed() {
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "none";
    setOrganizationLevelValue("");
    setOrganizationLevelShortValue("");
  }

  function removedAdd() {
    var mpopup = document.getElementById("AddNewOrganizationLevel");
    mpopup.style.display = "none";
    setOrganizationLevelValue("");
    setOrganizationLevelShortValue("");
  }

  function handleEditOrganizationLevel(value) {
    document.getElementById("OrganizationLevelEdit").value = value.deptName;
    document.getElementById("OrganizationLevelShortEdit").value = value.deptShortName;

    // localUserTypeName = value.userTypeName
    // document.getElementById("userTypeEdit").defaultValue= ""
    // document.getElementById("userTypeEdit").defaultValue = value.userTypeName;
    setEditCode({
      "deptCode":  value.deptCode,
      "visibility": value.visibility
    
    });

    
    setOrganizationLevelValue(document.getElementById("OrganizationLevelEdit").value)
    setOrganizationLevelShortValue(document.getElementById("OrganizationLevelShortEdit").value)

    //   setUserTypeValue(value.seasonName)
    var x = document.createElement("a");
    x.id = "mpopupLink";
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "block";
  }

  function AddNewOrganizationLevel() {
    if (OrganizationLevelValue && OrganizationLevelShortValue) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        createdByUC: localStorage.getItem("userCodeGlobal"),
        deptName: OrganizationLevelValue,
        deptShortName: OrganizationLevelShortValue,
        sortingOrder: 1
      
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/department`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          alert(JSON.parse(result).message);
          //   $('#addNewBtn').on('click', function () {
          // $('#addNewUserType').modal('hide');
          //  })
          if (JSON.parse(result).success === true) {
            // $('#addNewBtn').on('click', function () {
            // $('#addNewUserType').modal('hide');
            // })

            setFlag(true);
            setOrganizationLevelValue("");
            setOrganizationLevelShortValue("");
            removedAdd()
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      alert("Enter All Fields");
    }
  }

  function deleteData(value) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(deleteCode);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/department`, requestOptions)
        .then(response => response.text())
        .then(result => {
            if (JSON.parse(result).success === true) {
                fetchData()

            }
        })
        .catch(error => console.log('error', error));
}

function EditOrganizationLevel() {
    if (OrganizationLevelValue && OrganizationLevelShortValue) {
       
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({  

        "modifiedByUC": 1,
        "deptCode": editCode.deptCode,
        "deptName": OrganizationLevelValue,
        "sortingOrder": 15,
        "deptShortName": OrganizationLevelShortValue,
        "visibility": editCode.visibility
        
    });

    var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/department`, requestOptions)
        .then(response => response.text())
        .then(result => {
            alert(JSON.parse(result).message)
            if (JSON.parse(result).success === true) {
                setOrganizationLevelValue("")
                setOrganizationLevelShortValue("")
                fetchData()
                removed()


            }
        }
        )
        .catch(error => console.log('error', error));
    } else {
        alert("Enter All Fields");
      }
       
}

function handleOrganizationLevelValue(value) {
    const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
    document.getElementById("OrganizationLevelEdit").value = valueFinal;
    setOrganizationLevelValue(valueFinal)
}

function handleOrganizationLevelShortValue(value) {
    const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
    document.getElementById("OrganizationLevelShortEdit").value = valueFinal;
    setOrganizationLevelShortValue(valueFinal)
}

function handleAddNewData() {
    setOrganizationLevelValue("");
    setOrganizationLevelShortValue("");
    setFlag(false)
}

  return (
    <>
      <main id="main" className="main">
      <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
         
          <nav>
          <h1>Organization Level</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Master</li>
              <li className="breadcrumb-item active">Organization Level</li>
            </ol>
          </nav>
          <button
            type="button"
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#AddNewOrganizationLevel"
            onClick={() => handleAddNewData()}
          >
            Add New
          </button>
        </div>
        <section className="section">
          <div className="row justify-content-lg-center">
            <div className="col-lg-12 ">
              <div className="card">
                <MaterialReactTable
                  columns={columns}
                  data={OrganizationLevelData}
                  enableColumnOrdering
                  enablePagination={true}
                />
              </div>
            </div>

            <div className="col-lg-6"></div>
          </div>
          <div className="modal" id="AddNewOrganizationLevel">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                <label for="add_season" className="form-label">
                   <h4> Add New Organization Level</h4>
                  </label>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                <label for="add_season" className="form-label">
                Organization Level Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Organization Level Name"
                    onChange={(e) => handleOrganizationLevelValue(e.target.value)}
                    value={OrganizationLevelValue}
                    maxLength={50}
                  />
                  <br/>
                  <label for="add_season" className="form-label">
                  Organization Level Short Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Organization Level Short Name "
                    onChange={(e) => handleOrganizationLevelShortValue(e.target.value)}
                    value={OrganizationLevelShortValue}
                    maxLength={50}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    id="addNewBtn"
                    // data-bs-dismiss="modal"
                    onClick={AddNewOrganizationLevel}
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="mpopupBox" className="modal">
            <div className="modal-content">
            <div className="modal-header">
                <label for="add_season" className="form-label">
                   <h4> Edit Organization Level</h4>
                  </label>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>
              <div className="madal-body" id="modal-content">
              <label for="add_season" className="form-label">
                  Organization Level Name
                  </label>
                <input
                  type="text"
                  className="form-control"
                  id="OrganizationLevelEdit"
                  placeholder="Organization Level Name"
                  onChange={(e) => handleOrganizationLevelValue(e.target.value)}
                  maxLength={50}
                />
                <br/>
                <label for="add_season" className="form-label">
                  Organization Level Short Name
                  </label>
                <input
                  type="text"
                  className="form-control"
                  id="OrganizationLevelShortEdit"
                  placeholder="Organization Short Level Name"
                  onChange={(e) => handleOrganizationLevelShortValue(e.target.value)}
                  maxLength={50}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={EditOrganizationLevel}
                >
                  Add
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={removed}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <div className="modal" id="myDelete">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                  <p>Are you sure you want to delete this item?</p>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-dismiss="modal"
                    onClick={deleteData}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default OrganizationLevel;
